import { getResponseData } from '@/helpers/mocks';
import { HttpResponse, delay } from 'msw';

const RESPONSE = {
  default: {
    response: {
      createdAt: 1750583582707,
      error: {
        code: 0,
        label: '',
        message: '',
      },
      object: 'userlogin',
      success: true,
      data: {
        role: {
          code: '2',
          allowallowedRoutes: [
            'main',
            'login',
            'proposals',
          ],
        },
      },
    },
    error: {
      response: {
        createdAt: 1701115461239,
        object: 'login',
        success: false,
      },
      status: 500,
    },
  },
};

const userLoginHandler = async () => {
  const { response, status } = getResponseData(RESPONSE);
  await delay(1000);
  return HttpResponse.json(response, status);
};

export {
  userLoginHandler,
};
